import React from 'react'
import Select from 'react-select'
import { ChevronDown } from 'components/icons'
import { FormError } from 'components/atoms'
import styles from './FormSelect.module.sass'

export interface Option {
  label: string
  value: any
  selected?: boolean
}
export interface Props {
  id: string
  placeholder?: string
  name?: string
  value?: any
  className?: string
  required?: boolean
  disabled?: boolean
  size?: 'md' | 'lg'
  status?: '' | 'success' | 'error'
  errorMessage?: string
  onBlur?: (e: React.FocusEvent<HTMLElement>) => void
  onFocus?: (e: React.FocusEvent<HTMLElement>) => void
  onChange?: (e: any) => void
  isSearchable?: boolean
  options: Option[]
}

const FormSelectDropdownIndicator = () => (
  <div className="react-select__dropdown-indicator">
    <ChevronDown />
  </div>
)

const FormSelect = (props: Props) => {
  const {
    id = '',
    placeholder = '',
    name = '',
    value = null,
    className = '',
    required = false,
    disabled = false,
    size = 'md',
    status = '',
    errorMessage = '',
    onBlur = () => {},
    onFocus = () => {},
    onChange = () => {},
    options = [],
    isSearchable = false,
  } = props

  const classNames = ` 
    ${styles.root}
    ${status ? styles[`root--${status}`] : ''}
    ${className}`

  const reactSelectClassNames = ` 
    react-select
    ${size ? `react-select--${size}` : ''}
    ${status ? `react-select--${status}` : ''}
  `

  const convertOptionToEvent = (option) => ({
    target: {
      type: 'select',
      name: name,
      value: option?.value,
      label: option?.label,
    },
  })

  const onLocalChange = (option) => {
    onChange(convertOptionToEvent(option))
  }

  return (
    <div className={classNames}>
      <div className={styles.inputWrap}>
        <Select
          tabIndex={0}
          inputId={id}
          className={reactSelectClassNames}
          classNamePrefix="react-select"
          closeMenuOnSelect
          required={required}
          isClearable={false}
          isSearchable={isSearchable}
          isDisabled={disabled || false}
          instanceId={name}
          name={name}
          placeholder={placeholder}
          components={{ DropdownIndicator: FormSelectDropdownIndicator }}
          onChange={onLocalChange}
          onFocus={onFocus}
          onBlur={onBlur}
          options={options}
          value={
            options?.find((option) => option.selected) ||
            options?.find((option) => option.value === value)
          }
          aria-describedby={status === 'error' ? `${id}_error` : undefined}
          aria-invalid={status === 'error'}
        />
      </div>
      <FormError
        id={`${id}_error`}
        className={styles.error}
        message={errorMessage}
        visible={status === 'error'}
      />
    </div>
  )
}

export default FormSelect
